"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeApostrophes = exports.removeDashes = void 0;
/**
 * Removes dashes "-"
 *
 * @returns {string}
 */
function removeDashes(value) {
    return value.replace(/-/g, "");
}
exports.removeDashes = removeDashes;
/**
 * Replace apostrophes '’
 *
 * @returns {string}
 */
function removeApostrophes(value) {
    return value.replace(/['’]/g, "");
}
exports.removeApostrophes = removeApostrophes;
//# sourceMappingURL=stringSanitizer.js.map